


















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SvcAlergiObat from "@/services/AlergiObat";
import { appModule } from "@/store/modules/app";

import http from "@/axios/http-common";
interface DataAlergiObat {
  id: number | null;
  pasien_rm: string;
  kfa_id: string;
  reaksi: string;
  kfa: {};
}

@Component({
  components: {},
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalAlergiObat extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly disabled!: boolean;
  @Prop() readonly register;
  @Prop() readonly rm;
  @Prop({ required: true }) alergiObat!: DataAlergiObat;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;

  listKfa = [];
  loadingKfa = false;
  mounted() {}

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  @Watch("value")
  changeValue(val) {}

  close() {
    this.dialog = false;
    this.alergiObat = null;
  }

  async onSearchKfa(keyword: string) {
    if (keyword === null || keyword.length < 3) {
      this.listKfa = [];
      return;
    }
    this.loadingKfa = true;
    http
      .getDataParam("/referensi/kfa/search", {
        params: { term: keyword }
      })
      .then(res => {
        this.listKfa = res.data;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => (this.loadingKfa = false));
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;
      const save = this.alergiObat.id
        ? SvcAlergiObat.update(this.alergiObat.id, this.alergiObat)
        : SvcAlergiObat.create(this.alergiObat);
      save
        .then((resp: any) => {
          if (resp.status === 1) {
            appModule.NoticeDelay("Berhasil Menyimpan Alergi Obat");
            this.$emit("reload");
            this.dialog = false;
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  changeKfa(val: any) {
    this.alergiObat.kfa_id = val ? val.id : null;
  }
}
